// // THIS IS AN UNUSED PAGE
//
// import React, {Component} from 'react';
// import {connect} from 'react-redux';
// import {Loader} from '../../common/elements';
// import {NetworkHelpers as Network, BasketCheckHelper} from '../../../helpers';
// import * as basketActions from '../../../actions/transactions/basket';
// import * as purchaseActions from '../../../actions/transactions/purchases';
// import PageBanner from '../elements/PageBanner';
// import network_details from '../transactions/membership/data/network_details.json';
// import {Data, Components} from '../transactions/membership';
// import FirstLoginMembershipPage from '../transactions/membership/04_components/FirstLoginMembershipPage'
//
// class BundlesPage extends Component {
//   componentDidMount() {
//     const {getPackages, basket, getBasket, getPromotionalPricing} = this.props,
//       emailAddress = localStorage.getItem("email_address");
//
//     getPackages();
//
//     if (!basket.fetched) {
//       getBasket();
//     }
//     getPromotionalPricing(emailAddress);
//   };
//
//   render() {
//     // const { originalPackages, basket, params, promotional_packages, firstLoginToBundles, addPackageToBasket } = this.props;
//     const {originalPackages, basket, params, promotional_packages, addPackageToBasket} = this.props;
//     const firstLoginToBundles = true;
//     const packages = BasketCheckHelper.checkPackagesInBasket(originalPackages, basket);
//     // { description_first, description_second, testimonial } = network_details.network_details.find( detail => detail.network === networkId ),
//     // description = <div><p className="p-tag">{ description_first } </p> <p className="p-tag small">{ description_second } </p></div>;
//
//     if (packages.length === 0 || !basket.fetched || !promotional_packages) {
//       return <Loader />;
//     }
//     return (
//       <div>
//         <FirstLoginMembershipPage
//           packages={ packages }
//           promoPackages={ promotional_packages }
//           onAddToCartClicked={ addPackageToBasket }
//           firstLoginToBundles={ firstLoginToBundles }
//         />
//       </div>
//     );
//   }
// }
//
// const mapStateToProps = (state) => {
//   return {
//     basket: state.transactions.basket,
//     originalPackages: state.transactions.packages,
//     all_packages: state.transactions.all_packages,
//     promotional_packages: state.transactions.promotional_packages,
//     firstLoginToBundles: state.authentication.firstLoginToBundles
//   };
// };
//
// const mapDispatchToProps = (dispatch) => {
//   return {
//     addPackageToBasket: (packageId) => dispatch(basketActions.addPackageToBasket(packageId)),
//     getPackages: (network) => dispatch(purchaseActions.getPackages(network)),
//     getBasket: () => dispatch(basketActions.getBasket()),
//     getPromotionalPricing: email => dispatch(purchaseActions.getPromotionPrices(email))
//   };
// };
//
// export default connect(mapStateToProps, mapDispatchToProps)(BundlesPage);


// WEBPACK FOOTER //
// src/client/components/common/purchases/BundlesPage.js